"use client";

import { useActivityTracking } from "@/lib/hooks/useActivityTracking";

export default function ActivityTracker() {
  useActivityTracking();
  return null;
}
